var KissTariffsPassContent = /*@__PURE__*/ (function () {
    function KissTariffsPassContent(passId, passTitle, passDescription, passTooltipHeadline, passTooltipContent) {
        this.classList = ["mod-ep-kiss-tariffs__pass-content", "ep-shop-tab-selection__tab-content"];
        this.TITLE_PLACEHOLDER = "PASS_TITLE";
        this.DESCRIPTION_PLACEHOLDER = "PASS_DESCRIPTION";
        this.TOOLTIP_HEADLINE_PLACEHOLDER = "TOOLTIP_HEADLINE";
        this.TOOLTIP_CONTENT_PLACEHOLDER = "TOOLTIP_CONTENT";
        this.template = "    <div class=\"mod-ep-kiss-tariffs__pass-title\">" + this.TITLE_PLACEHOLDER +
            "                                                        <div class=\"info-icon\">" +
            "                                                        <span class=\"mod mod-tooltip2\"" +
            "                                                              data-aligned=\"right\"\n" +
            "                                                              data-content=\"" + this.TOOLTIP_CONTENT_PLACEHOLDER + "\"" +
            "                                                              data-headline=\"" + this.TOOLTIP_HEADLINE_PLACEHOLDER + "\">" +
            "                                                            <span class=\"tt-handle\">&nbsp;</span>" +
            "                                                        </span>" +
            "                                                    </div>" +
            "                                                </div>" +
            "                                                <div>" +
            this.DESCRIPTION_PLACEHOLDER +
            "                                                </div>";
        this.container = document.createElement("div");
        this.container.classList.add("mod-ep-kiss-tariffs__pass-content");
        this.container.classList.add("ep-shop-tab-selection__tab-content");
        this.passId = passId;
        this.passTitle = passTitle;
        this.passDescription = passDescription;
        this.tooltipHeadline = passTooltipHeadline;
        this.tooltipContent = passTooltipContent;
        this.selected = false;
        this.setup();
        this.container.innerHTML = this.template;
        window.vf.tooltip2.init(this.container);
    }
    KissTariffsPassContent.prototype.setup = function () {
        while (this.template.indexOf(this.TITLE_PLACEHOLDER) > -1) {
            this.template = this.template.replace(this.TITLE_PLACEHOLDER, this.passTitle);
        }
        while (this.template.indexOf(this.DESCRIPTION_PLACEHOLDER) > -1) {
            this.template = this.template.replace(this.DESCRIPTION_PLACEHOLDER, this.passDescription);
        }
        while (this.template.indexOf(this.TOOLTIP_HEADLINE_PLACEHOLDER) > -1) {
            this.template = this.template.replace(this.TOOLTIP_HEADLINE_PLACEHOLDER, this.tooltipHeadline);
        }
        while (this.template.indexOf(this.TOOLTIP_CONTENT_PLACEHOLDER) > -1) {
            this.template = this.template.replace(this.TOOLTIP_CONTENT_PLACEHOLDER, this.tooltipContent);
        }
    };
    KissTariffsPassContent.prototype.setSelected = function (selected) {
        if (selected) {
            this.container.classList.add("selected");
        }
        else {
            this.container.classList.remove("selected");
        }
    };
    KissTariffsPassContent.prototype.render = function () {
        return this.container;
    };
    return KissTariffsPassContent;
}());
export { KissTariffsPassContent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/widgets/kiss-tariffs/kiss-tariffs-pass-content.ts
// module id = null
// module chunks = 